import { UtilityService } from '../../../../common/services/Utility.service';
import { showPhoneNumberInString, formatDob } from '../../../../common/utils/common';
import { CustomerType, Gender } from '../tabs/user/detail_user.const';
import { moment } from 'ngx-bootstrap/chronos/test/chain';

export enum AssignType {
  All,
  Me,
  MyOrganization,
  MyGroup,
  MyCustomerGroup,
}

export const AssignList = [
  {
    id: AssignType.All,
    title: 'Tất cả',
  },
  {
    id: AssignType.MyGroup,
    title: 'Bộ phận của tôi',
  },
  {
    id: AssignType.MyOrganization,
    title: 'Tổ chức của tôi',
  },
  {
    id: AssignType.MyCustomerGroup,
    title: 'Nhóm khách hàng của tôi',
  },
];

export function getParams(data: AssignType) {
  switch (data) {
    default:
      return 'all';
  }
}
export class CustomerConst {
  static displayColumns = (fields: { title: string; key: string }[] = []) => {
    let data = [
      {
        title: 'Tên khách hàng',
        key: 'display_name',
        display: true,
        allowSort: false,
        classes: '',
        field: 'name',
      },
      {
        title: 'Số điện thoại',
        key: 'display_phone',
        display: true,
        allowSort: false,
        classes: '',
        field: 'phone',
      },
      {
        title: 'Email',
        key: 'display_email',
        display: true,
        allowSort: false,
        classes: '',
        field: 'email',
      },
      {
        title: 'Ngày sinh',
        key: 'display_dob',
        display: true,
        allowSort: false,
        classes: '',
        field: 'dob',
      },
      {
        title: 'Nguồn',
        key: 'display_source',
        display: true,
        allowSort: false,
        classes: 'text-center',
        field: 'source',
      },
      {
        title: 'Tổ chức',
        key: 'display_organize',
        display: true,
        allowSort: false,
        classes: '',
        field: 'organize_id',
      },
      {
        title: 'Nhóm khách hàng',
        key: 'display_group',
        display: true,
        allowSort: false,
        classes: '',
        field: 'group_id',
      },
      {
        title: 'Thành phố',
        key: 'display_city',
        display: true,
        allowSort: false,
        classes: '',
        field: 'city',
      },
      {
        title: 'Thời gian khởi tạo',
        key: 'display_created_at',
        display: true,
        allowSort: false,
        classes: 'text-center',
        field: 'created_at',
      },

      {
        title: 'Cập nhật lần cuối',
        key: 'display_updated_at',
        display: false,
        allowSort: false,
        classes: 'text-center',
        field: 'updated_at',
      },
      {
        title: 'Hạng khách hàng',
        key: 'display_customer_type',
        display: false,
        allowSort: false,
        classes: 'text-center',
        field: 'customer_type',
      },

      {
        title: 'Facebook',
        key: 'display_facebook',
        display: false,
        allowSort: false,
        classes: 'text-center',
        field: 'facebook',
      },
      {
        title: 'Số điện thoại phụ',
        key: 'display_sub_phone',
        display: false,
        allowSort: false,
        classes: 'text-center',
        field: 'sub_phone',
      },
      {
        title: 'Email phụ',
        key: 'display_sub_email',
        display: false,
        allowSort: false,
        classes: 'text-center',
        field: 'sub_email',
      },
      {
        title: 'Giới tính',
        key: 'display_gender',
        display: false,
        allowSort: false,
        classes: 'text-center',
        field: 'gender',
      },

      {
        title: 'Quận huyện',
        key: 'display_district',
        display: false,
        allowSort: false,
        classes: 'text-center',
        field: 'district_id',
      },
      {
        title: 'Địa chỉ',
        key: 'address',
        display: false,
        allowSort: false,
        classes: 'text-center',
        field: 'address',
      },
      {
        title: 'Tag',
        key: 'tags',
        display: false,
        allowSort: false,
        classes: 'text-center',
        field: 'tags',
      },
      {
        title: 'Ghi chú',
        key: 'note',
        display: false,
        allowSort: false,
        classes: 'text-center',
        field: 'note',
      },
    ];
    if (fields.length > 0) {
      fields.forEach(f => {
        data.push({
          title: f.title,
          key: 'display_' + f.key,
          display: false,
          allowSort: false,
          classes: '',
          field: f.key,
        });
      });
    }
    return data;
  };
  static displayCodeColumns = item => {
    return `<a class="text_link" href="javascript:void(0)">${item.code}</a>`;
  };
  static displayNameColumns = (item, user) => {
    return item.name ? showPhoneNumberInString(item.name, user) : 'Chưa xác định';
  };
  static displayPhoneColumns = (item, user) => {
    return item.phone ? showPhoneNumberInString(item.phone, user) : 'Chưa xác định';
  };
  static displayEmailColumns = item => {
    return item.email ? item.email : 'Chưa xác định';
  };
  static displayOrganizeColumns = item => {
    return item.organize ? item.organize.text : 'Chưa xác định';
  };
  static displayGroupColumns = item => {
    return item.group ? item.group.text : 'Chưa xác định';
  };
  static displayCityColumns = item => {
    return item.city ? item.city.text : 'Chưa xác định';
  };

  static displayDob = item => {
    return formatDob(item.dob);
  };

  static displayDistrictColumns = item => {
    return item.district ? item.district.text : '';
  };
  static displaySourceColumns = item => {
    switch (item.source) {
      case 'call':
        if (item.source_detail == 'CALL_INBOUND') {
          return `<i><img src="../../../../../assets/icons/in-coming-1.svg" alt=""/></i>`;
        }
        if (item.source_detail == 'CALL_OUTBOUND') {
          return `<i><img src="../../../../../assets/icons/out-going-1.svg" alt=""/></i>`;
        }
        break;
      case 'CALL_INBOUND':
        return `<i><img src="../../../../../assets/icons/in-coming-1.svg" alt=""/></i>`;
      case 'CALL_OUTBOUND':
        return `<i><img src="../../../../../assets/icons/out-going-1.svg" alt=""/></i>`;
      case 'email':
        return `<i class="icon fa fa-envelope"></i>`;
      case 'web':
        return `<i class="icon fa fa-comments"></i>`;
      case 'hand':
        return `<i class="icon fa fa-edit"></i>`;
      case 'facebook':
        return `<i class="icon fa fa-facebook"></i>`;
      case 'zalo':
        return `<i><img src="../../../../../assets/images/zalo-black.png" width="16" alt=""/></i>`;
      default:
        return 'Chưa xác định';
    }
  };
  static displayTimeColumns = time => {
    return UtilityService.dateFormat(time);
  };
  static displayCustomerTypeColumns = item => {
    const type = CustomerType.find(type => type.id === item.customer_type);
    return type ? type.text : '';
  };
  static displayFacebookColumns = item => {
    return item.facebook ? item.facebook.join(', ') : '';
  };
  static displaySubPhoneColumns = (item, user) => {
    return item.sub_phone ? showPhoneNumberInString(item.sub_phone.join(', '), user) : '';
  };
  static displaySubEmailColumns = item => {
    return item.sub_email ? item.sub_email.join(', ') : '';
  };
  static displayGenderColumns = item => {
    const gender = Gender.find(gender => gender.id === item.gender);
    return gender ? gender.text : '';
  };
  static displayFieldColumn = (data, t) => {
    if (!data) return '';
    return data[t.key]
      ? t.type === 'date'
        ? moment(data[t.key]).add('-7', 'hours').format('YYYY-MM-DD HH:mm')
        : data[t.key]
      : '';
  };
}



// WEBPACK FOOTER //
// ./src/app/pages/admin/icontact/customer/customer.const.ts